import { useCallback, useEffect, useState } from 'react';
import { get } from './api';
import selectBranch from './selectBranch';
import { useAuth } from '../context/AuthContext';
import { clearBranchPreference, guestBranchId } from './branchPreference';
export default function useBranches() {
  const { user } = useAuth();
  const [state, setState] = useState({ branches: [], currentBranch: null, loading: true, error: '' });
  const [revision, setRevision] = useState(0);
  useEffect(() => {
    const reload = () => setRevision(value => value + 1);
    window.addEventListener('branch-changed', reload);
    return () => window.removeEventListener('branch-changed', reload);
  }, []);
  useEffect(() => {
    let active = true;
    setState(previous => ({ ...previous, loading: true, error: '' }));
    get('/branches?' + new URLSearchParams({ branchId: guestBranchId() }))
      .then(response => {
        if (!active) return;
        const branches = response.branches || [];
        const saved = guestBranchId();
        if (saved && !branches.some(branch => branch.id === saved)) {
          clearBranchPreference();
          window.dispatchEvent(new Event('catalog-preference-changed'));
        }
        setState({ branches, currentBranch: response.currentBranch, loading: false, error: '' });
      })
      .catch(error => { if (active) setState(previous => ({ ...previous, loading: false, error: error.response?.data?.message || 'Unable to load platform areas.' })); });
    return () => { active = false; };
  }, [user?.id, user?.userId, user?.role, revision]);
  const select = useCallback(branch => selectBranch(branch, user), [user]);
  return { ...state, select };
}
